export const getStylesByKeys = (str = "") => {
    if (!str) return {};

    const styles = {};

    const styleMap = {
        bold: () => styles.fontWeight = 'bold',
        thin: () => styles.fontWeight = '100',
        italic: () => styles.fontStyle = 'italic',
        underline: () => styles.textDecorationLine = 'underline',
        'line-through': () => styles.textDecorationLine = 'line-through',

        'size-sm': () => styles.fontSize = '0.875rem',
        'size-lg': () => styles.fontSize = '1.125rem',
        'size-xl': () => styles.fontSize = '1.25rem',

        left: () => {
            styles.textAlign = 'left';
            styles.display = 'block';
        },
        center: () => {
            styles.textAlign = 'center';
            styles.display = 'block';
        },
        right: () => {
            styles.textAlign = 'right';
            styles.display = 'block';
        },
        justify: () => styles.textAlign = 'justify',

        gray: () => styles.color = 'rgb(107 114 128)',
        red: () => styles.color = 'rgb(239 68 68)',

        'bg-gray': () => styles.backgroundColor = 'rgb(209 213 219)',

        shadow: () => styles.boxShadow =
            '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',

        'shadow-md': () => styles.boxShadow =
            '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    };

    str.split(',')
        .map(e => e.trim())
        .forEach(key => {
            if (styleMap[key]) styleMap[key]();
        });

    return styles;
};
